<seech-shared-progress-bar class="w-100" [shape]="shape" [progress]="progress" [borderRadius]="borderRadius"
  [isIndeterminate]="isIndeterminate" [height]="height" [color]="color"></seech-shared-progress-bar>